import { ResendVoucherRequest, SendVoucherRequest } from "../../models/voucher";
import { callApi } from "./utils";

export class VoucherService {

    getVoucherStatus = async (bankId: string) => {
        try {              
            const response = await callApi(`Admin/VoucherStatus/${bankId}`, 'GET');
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }

    getVoucherHistory = async (bankId: string) => {
        try {              
            const response = await callApi(`Admin/VoucherHistory/${bankId}`, 'GET');
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }

    exportHistory = async (bankId: string) => {
        try {              
            const response = await callApi(`Admin/ExportVoucherHistory/${bankId}`, 'GET');
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }
    
    sendVoucher = async (request: SendVoucherRequest) => {
        try {              
            const response = await callApi(`Admin/UseVoucher`, 'POST', request);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }
    
    resendVoucher = async (request: ResendVoucherRequest) => {
        try {              
            const response = await callApi(`Admin/ResendMail`, 'POST', request);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }
    
    cancelVoucher = async (request: ResendVoucherRequest) => {
        try {              
            const response = await callApi(`Admin/CancelVoucher`, 'POST', request);
            return response;
        } catch (error) {
            console.error(error);
            throw new Error();
        }
    }

    
}